import React from "react";
import stretcher from "../assets/img/why/stretcher.webp";
import oxygen from "../assets/img/why/oxygen.webp";
import help from "../assets/img/why/help.webp";
import mapPin from "../assets/img/why/map-pin.webp";
import wheelchair from "../assets/img/why/wheelchair.webp";
import medicalTechnician from "../assets/img/why/medical-technician.webp";

function WhyChoose() {
  const whyUsData = [
    {
      img: stretcher,
      text: "Every ambulance is equipped with a stretcher for safe and efficient patient transport, ensuring timely and secure medical assistance.",
    },
    {
      img: oxygen,
      text: "Oxygen supply is available in all ambulances, providing critical respiratory support for emergency medical situations.",
    },
    {
      img: help,
      text: "Trained personnel available to assist with patient lifting and handling, ensuring comfort and safety during transport.",
    },
    {
      img: mapPin,
      text: "Interstate ambulance services available, enabling hassle-free patient transportation across different regions.",
    },
    {
      img: wheelchair,
      text: "Complimentary wheelchair assistance is provided upon request, ensuring smooth mobility for patients at no extra charge.",
    },
    {
      img: medicalTechnician,
      text: "Expert Emergency Medical Technicians (EMTs) trained in Basic and Advanced Life Support to handle critical situations effectively.",
    },
  ];

  return (
    <section id="aboutus" className="about-us">
      <div className="container">
        <div className="why-us">
          <h1 className="fade-out fade-in ">WHY CHOOSE US</h1>
          <h6 className="fade-out fade-in ">
            When you need reliable ambulance services in India, trust IHU (Indian Health Unit)
            Healthcare. We are committed to providing high-quality medical transport solutions tailored to your needs.
          </h6>
          <div className="row why-contain">
            {whyUsData.map((item, index) => (
              <div key={index} className="col4">
                <div className="why-card">
                  <img className="fade-out fade-in fade-out-right" src={item.img} alt="Why Choose Us" />
                  <p className="fade-out fade-in">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyChoose;
